import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import history from 'utils/history';
import appReducer from 'containers/App/reducer';
import languageProviderReducer from 'containers/LanguageProvider/reducer';
import snackbarReducer from './store/snackbar/reducer';
import loaderReducer from 'components/LoaderComponent/reducer';

export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    app: appReducer,
    language: languageProviderReducer,
    router: connectRouter(history),
    snackbar: snackbarReducer,
    loader: loaderReducer,
    ...injectedReducers,
  });

  return rootReducer;
}
